import type { NavigateFunction, NavigateOptions, To } from 'react-router-dom';

let routerNavigate: NavigateFunction | null = null;

export function setRouterNavigate(navigate: NavigateFunction | null) {
  routerNavigate = navigate;
}

export function navigateTo(to: To, options?: NavigateOptions) {
  if (routerNavigate) {
    routerNavigate(to, options);
  }
}
